<div mat-dialog-title class="dialog-header" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
	<div class="flex flex-col min-w-0">
		<span>{{ title() }}</span>
		@if (subtitle()) {
			<span class="text-sm font-normal text-secondary truncate">{{ subtitle() }}</span>
		}
	</div>
	<div class="header-actions">
		<!-- Optionale Steuerelemente im Kopf (z.B. ein Standard/Experte-Umschalter), projiziert vom Aufrufer. -->
		<ng-content select="[dialogHeaderActions]" />
		<button araButton="icon" type="button" class="close-btn" [disabled]="closeDisabled()" (click)="closed.emit()">
			<mat-icon>close</mat-icon>
		</button>
	</div>
</div>
